import React, { useState, useEffect, useRef, forwardRef } from 'react';
import './style.css';

const Animations = forwardRef(({ children, type = 'fadeInUp', delay = '0s', loaded }, ref) => {
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef(null);

    useEffect(() => {
        // We create an intersection observer to check when the element is in view
        const observer = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (entry.isIntersecting) {
                    // Here, we check if loaded is undefined or true, and then proceed
                    if (loaded === undefined || loaded) {
                        setTimeout(() => {
                            setIsVisible(true);
                        }, parseFloat(delay) * 1000);
                    }
                    observer.unobserve(entry.target);
                }
            },
            { root: null, threshold: 0.1 }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => {
            if (elementRef.current) {
                observer.unobserve(elementRef.current);
            }
        };
    }, [loaded, delay]);

    const animationClasses = `animate__${type} ${isVisible ? 'animate__animated' : ''}`;

    // Combine refs function
    const combinedRef = node => {
        elementRef.current = node;
        if (typeof ref === 'function') {
            ref(node);
        } else if (ref) {
            ref.current = node;
        }
    };

    if (React.isValidElement(children)) {
        const childClassName = children.props.className || '';
        const newProps = {
            ...children.props,
            className: `${childClassName} ${animationClasses}`.trim(),
            style: { ...children.props.style, animationDelay: delay },
            ref: combinedRef
        };

        return React.cloneElement(children, newProps);
    }

    return children;
});

export default Animations;
